import { AddVehicle } from '../../../src/components'

export default function Index() {
  return (
    <div className="cure-inner-container">
      <AddVehicle />
    </div>
  )
}
